import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "gameLabel",
})
export class GameLabelPipe implements PipeTransform {
  transform(score: number): string {
    switch (score) {
      case 10:
        return "<span>¡Vas a toda velocidad! <br /> &nbsp;</span>";
      case 20:
        return "<span>Descubre la ruta correcta <br /> y suma puntos</span>";
      case 30:
        return "<span>Encuentra la pareja <br /> y avanza en tu viaje</span>";
      case 40:
        return "<span>Tu memoria está <br /> en movimiento</span>";
      case 50:
        return "<span>¡Excelente!</span>";
      default:
        return "<span>&nbsp; <br /> &nbsp;</span>";
    }
  }
}
